export type RequestHistoryDomain = 'ProductDomain' | 'CategoryMetaDomain';

export const USED_IN_OPTIONS: { value: RequestHistoryDomain; label: string }[] = [
	{ value: 'ProductDomain', label: 'Product' },
	{ value: 'CategoryMetaDomain', label: 'Category' },
];

export const AREA_OPTIONS_BY_DOMAIN: Record<
	RequestHistoryDomain,
	{ value: string; label: string }[]
> = {
	ProductDomain: [
		{ value: 'ProductName', label: 'Title' },
		{ value: 'ProductDescription', label: 'Description' },
		{ value: 'SizeText', label: 'Size' },
		{ value: 'ProductColourName', label: 'Colour Name' },
		{ value: 'ProductMetaKeywords', label: 'Meta Keywords' },
		{ value: 'ProductMetaDescription', label: 'Meta Description' },
		{ value: 'AttributeValue', label: 'Attribute Value' },
		{ value: 'AttributeDisplayName', label: 'Attribute Name' },
	],
	CategoryMetaDomain: [
		{ value: 'CategoryMetaTitle', label: 'Title' },
		{ value: 'CategoryDescription', label: 'Description' },
		{ value: 'CategoryMetaHeader', label: 'Header' },
		{ value: 'CategoryMetaKeywords', label: 'Meta Keywords' },
		{ value: 'CategoryMetaDescription', label: 'Meta Description' },
		{ value: 'CategoryMetaHeaderLink', label: 'Header Link' },
		{ value: 'CategoryFilterDisplayText', label: 'Filter' },
		{ value: 'CategoryMetaDirectChildrenDisplayName', label: 'Child Title' },
		{ value: 'CategoryMetaParentDisplayName', label: 'Parent Title' },
	],
};

// combined areas only offered on the Product/Category lookup tab
export const LOOKUP_EXTRA_AREAS: Record<RequestHistoryDomain, { value: string; label: string }[]> = {
	ProductDomain: [
		{ value: 'FullProduct', label: 'Full Product' },
		{ value: 'ProductLite', label: 'Product Lite' },
	],
	CategoryMetaDomain: [{ value: 'FullCategory', label: 'Full Category' }],
};

// detail row for an item whose domain text has changed or whose product / category no longer exists
export const NO_MATCH_FIELD: [string, string] = ['Current match', 'None found'];
